import { render, staticRenderFns } from "./QuotationTemplate.vue?vue&type=template&id=4695d477"
import script from "./QuotationTemplate.vue?vue&type=script&lang=js"
export * from "./QuotationTemplate.vue?vue&type=script&lang=js"
import style0 from "./QuotationTemplate.vue?vue&type=style&index=0&id=4695d477&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports